import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

export default class DocumentosPaf extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: null,
            total: [],
            modalTransferenciaAberto: false,
            buscaTransferencia: '',
            resultadosTransferencia: [],
            estabelecimentoSelecionado: null,
            buscandoTransferencia: false,
            transferindoPropriedade: false,
            operacaoOcultacao: null
        }
        this.transferenciaTimeout = null
        this.highlightedRowRef = React.createRef()
        this.highlightScrollRealizado = false
    }

    componentDidMount() {
        this.carregarPaf()
    }

    componentDidUpdate(prevProps, prevState) {
        const highlightAnterior = this.getHighlightCod(prevProps)
        const highlightAtual = this.getHighlightCod()

        if (highlightAnterior !== highlightAtual) {
            this.highlightScrollRealizado = false
        }

        if (prevState.total !== this.state.total || highlightAnterior !== highlightAtual) {
            this.scrollToHighlightedRow()
        }
    }

    componentWillUnmount() {
        if (this.transferenciaTimeout) {
            clearTimeout(this.transferenciaTimeout)
        }
    }

    getHighlightCod = (props = this.props) => {
        const search = props && props.location ? props.location.search || '' : ''
        const params = new URLSearchParams(search)
        return String(params.get('highlightCod') || '').trim().toLowerCase()
    }

    isHighlightedFicha = (ficha) => {
        const highlightCod = this.getHighlightCod()
        const fichaCod = String(ficha && ficha.cod ? ficha.cod : '').trim().toLowerCase()

        return Boolean(highlightCod && fichaCod && highlightCod === fichaCod)
    }

    getHighlightedRowStyle = (ficha) => {
        if (!this.isHighlightedFicha(ficha)) {
            return undefined
        }

        return {
            backgroundColor: '#fff7d6',
            boxShadow: 'inset 4px 0 0 #f0ad4e',
            transition: 'background-color 0.3s ease'
        }
    }

    setHighlightedRowRef = (node, ficha) => {
        if (this.isHighlightedFicha(ficha)) {
            this.highlightedRowRef.current = node
        }
    }

    scrollToHighlightedRow = () => {
        const highlightCod = this.getHighlightCod()

        if (!highlightCod || this.highlightScrollRealizado || !this.highlightedRowRef.current) {
            return
        }

        this.highlightScrollRealizado = true
        this.highlightedRowRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    carregarPaf = () => {
        const id = this.props.match.params.id
        const url = `/api/paf/getPaf/${id.slice(0, 24)}`
        axios(url)
            .then(resp => {
                const list = resp.data
                const total = []
                total.push(...(list.documentos || []))
                total.push(...(list.despachos || []))
                total.push(...(list.anexos || []).map(a => ({ ...a, __tipo: 'anexo' })))
                total.push(...(list.certidoes || []))
                total.sort((a, b) => {
                    if (a.__tipo === 'anexo' && b.__tipo === 'anexo') {
                        const ao = typeof a.ordem === 'number' ? a.ordem : 0
                        const bo = typeof b.ordem === 'number' ? b.ordem : 0
                        return ao - bo
                    }
                    return new Date(a.createdAt) - new Date(b.createdAt)
                })
                this.setState({ list, total })
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }

    redirect(url) {
        window.open(url, '_blank')
    }

    excluir(id, tipo, excluir) {
        const idProcesso = this.props.match.params.id
        const url = `/api/paf/excluir/${idProcesso}`
        let ficha = { id, tipo, excluir }
        axios.post(url, ficha)
            .then(res => {
                alert(res.data)
                window.location = `/documentosPaf/${idProcesso}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    ocultar(ficha, despacho) {
        const id = this.props.match.params.id
        if (despacho) {
            var doc = { ficha, despacho }
        } else {
            var doc = { ficha }
        }
        const url = `/api/paf/ocultar/${id}`
        axios.post(url, doc)
            .then(() => {
                window.location = `/documentosPaf/${id}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    desocultar(ficha, tipo) {
        const id = this.props.match.params.id
        const operacaoOcultacao = `${tipo}:${ficha}`

        if (this.state.operacaoOcultacao === operacaoOcultacao) {
            return
        }

        const url = `/api/paf/desocultar/${id}`
        this.setState({ operacaoOcultacao })
        axios.post(url, { ficha, tipo })
            .then(res => {
                alert(res.data)
                this.setState({ operacaoOcultacao: null })
                this.carregarPaf()
            })
            .catch(error => {
                this.setState({ operacaoOcultacao: null })
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }

    isInterno = () => localStorage.tipo === 'interno'

    deveRenderizarFichaOculta = (ficha) => !(ficha && ficha.oculto == 'sim') || this.isInterno()

    getLinhaOcultaStyle = (ficha) => {
        const baseStyle = this.getHighlightedRowStyle(ficha) || {}

        if (!ficha || ficha.oculto != 'sim' || !this.isInterno()) {
            return Object.keys(baseStyle).length > 0 ? baseStyle : undefined
        }

        return {
            ...baseStyle,
            backgroundColor: baseStyle.backgroundColor || '#f8f9fa',
            opacity: 0.72,
            borderLeft: '4px solid #dc3545'
        }
    }

    renderBadgeOculto = (ficha) => {
        if (!ficha || ficha.oculto != 'sim' || !this.isInterno()) {
            return null
        }

        return (
            <span style={{
                display: 'inline-block',
                marginLeft: '0.5rem',
                padding: '0.1rem 0.45rem',
                borderRadius: '999px',
                backgroundColor: '#dc3545',
                color: '#fff',
                fontSize: '0.72rem',
                fontWeight: 700,
                verticalAlign: 'middle'
            }}>Oculto</span>
        )
    }

    renderBotaoVisibilidade = (fichaId, tipo, oculto) => {
        if (!this.isInterno()) {
            return null
        }

        const operacaoOcultacao = `${tipo}:${fichaId}`
        const carregando = this.state.operacaoOcultacao === operacaoOcultacao

        if (oculto == 'sim') {
            return (
                <button style={{
                    border: 'none', backgroundColor: '#17a2b8', outline: 'none',
                    height: '25px',
                    paddingLeft: '12px', paddingRight: '12px',
                    borderRadius: '15px', color: '#FFFF', marginRight: '1vw',
                    opacity: carregando ? 0.7 : 1,
                    cursor: carregando ? 'progress' : 'pointer'
                }} disabled={carregando} onClick={() => this.desocultar(fichaId, tipo)}>{carregando ? 'Salvando...' : 'Desocultar'}</button>
            )
        }

        return (
            <button style={{
                border: 'none', backgroundColor: '#dc3545', outline: 'none',
                height: '25px',
                paddingLeft: '12px', paddingRight: '12px',
                borderRadius: '15px', color: '#FFFF', marginRight: '1vw'
            }} onClick={() => this.ocultar(fichaId, tipo === 'documento' ? undefined : tipo)}>Ocultar</button>
        )
    }

    alerta() {
        const id = this.props.match.params.id
        const url = `/api/paf/alerta/${id}`
        axios.get(url)
            .then(res => {
                alert(res.data)
                window.location = `/documentosPaf/${id}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    deleteTv(object) {
        const url = `/api/tvs/delete`
        axios.post(url, object)
            .then(res => {
                alert(res.data)
                window.location = `/documentosPaf/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error)
            })
    }

    moverAnexo(anexoId, direcao) {
        const idPaf = this.props.match.params.id
        const url = `/api/paf/anexo/mover/${idPaf}`
        axios.post(url, { anexoId, direcao })
            .then(() => {
                this.carregarPaf()
            })
            .catch(error => {
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }


    formatarCpfCnpj = (valor) => {
        const digitos = String(valor || '').replace(/\D/g, '').slice(0, 14)

        if (digitos.length <= 11) {
            return digitos
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
        }

        return digitos
            .replace(/(\d{2})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2')
            .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
    }

    abrirModalTransferencia = () => {
        this.setState({
            modalTransferenciaAberto: true,
            buscaTransferencia: '',
            resultadosTransferencia: [],
            estabelecimentoSelecionado: null,
            buscandoTransferencia: false,
            transferindoPropriedade: false,
            operacaoOcultacao: null
        })
    }

    fecharModalTransferencia = () => {
        if (this.transferenciaTimeout) {
            clearTimeout(this.transferenciaTimeout)
            this.transferenciaTimeout = null
        }

        this.setState({
            modalTransferenciaAberto: false,
            buscaTransferencia: '',
            resultadosTransferencia: [],
            estabelecimentoSelecionado: null,
            buscandoTransferencia: false,
            transferindoPropriedade: false,
            operacaoOcultacao: null
        })
    }

    buscarEstabelecimentosTransferencia = (valor) => {
        const digitos = String(valor || '').replace(/\D/g, '')

        if (!digitos) {
            this.setState({ resultadosTransferencia: [], buscandoTransferencia: false })
            return
        }

        this.setState({ buscandoTransferencia: true })
        axios.post('/api/paf/buscaEstabelecimentoTransferencia', { valor })
            .then(resp => {
                this.setState({ resultadosTransferencia: resp.data || [], buscandoTransferencia: false })
            })
            .catch(error => {
                this.setState({ buscandoTransferencia: false, resultadosTransferencia: [] })
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }

    handleBuscaTransferenciaChange = (e) => {
        const buscaTransferencia = this.formatarCpfCnpj(e.target.value)
        const digitos = buscaTransferencia.replace(/\D/g, '')

        if (this.transferenciaTimeout) {
            clearTimeout(this.transferenciaTimeout)
        }

        this.setState({
            buscaTransferencia,
            estabelecimentoSelecionado: null
        })

        if (!digitos) {
            this.setState({ resultadosTransferencia: [], buscandoTransferencia: false })
            return
        }

        this.transferenciaTimeout = setTimeout(() => {
            this.buscarEstabelecimentosTransferencia(buscaTransferencia)
        }, 350)
    }

    selecionarEstabelecimentoTransferencia = (estabelecimentoSelecionado) => {
        this.setState({ estabelecimentoSelecionado })
    }

    confirmarTransferenciaPropriedade = () => {
        const { list, estabelecimentoSelecionado } = this.state

        if (!estabelecimentoSelecionado) {
            alert('Selecione um estabelecimento de destino para continuar.')
            return
        }

        if (String(estabelecimentoSelecionado.cpfCnpj || '').replace(/\D/g, '') === String(list.cpfCnpj || '').replace(/\D/g, '')) {
            alert('O estabelecimento de destino deve ser diferente do atual.')
            return
        }

        this.setState({ transferindoPropriedade: true })
        axios.post('/api/paf/transferirPropriedade', {
            pafId: list._id,
            cpfCnpjNovo: estabelecimentoSelecionado.cpfCnpj,
            estabelecimentoNovoId: estabelecimentoSelecionado._id
        })
            .then(res => {
                alert(res.data || 'Propriedade transferida com sucesso!')
                this.fecharModalTransferencia()
                this.carregarPaf()
            })
            .catch(error => {
                this.setState({ transferindoPropriedade: false })
                const mensagemErro = error && error.response && error.response.data ? error.response.data : (error.message || error)
                alert(mensagemErro)
            })
    }

    renderBotaoTransferencia() {
        if (localStorage.tipo !== 'interno') {
            return null
        }

        return (
            <button style={{
                border: 'none', backgroundColor: '#8d0801', outline: 'none',
                height: '32px',
                paddingLeft: '14px', paddingRight: '14px',
                borderRadius: '16px', color: '#FFFF', marginTop: '1rem'
            }} onClick={this.abrirModalTransferencia}>Transferir propriedade</button>
        )
    }

    renderModalTransferencia() {
        const {
            modalTransferenciaAberto,
            buscaTransferencia,
            resultadosTransferencia,
            estabelecimentoSelecionado,
            buscandoTransferencia,
            transferindoPropriedade,
            list
        } = this.state

        if (!modalTransferenciaAberto || !list) {
            return null
        }

        return (
            <div style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.55)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '1rem'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    width: '100%',
                    maxWidth: '640px',
                    padding: '1.5rem',
                    boxShadow: '0 12px 30px rgba(0, 0, 0, 0.2)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        <div>
                            <h3 style={{ margin: 0 }}>Transferir propriedade do PAF</h3>
                            <small>Altere apenas o vínculo de propriedade deste PAF.</small>
                        </div>
                        <button onClick={this.fecharModalTransferencia} style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', lineHeight: 1 }}>×</button>
                    </div>

                    <div style={{ backgroundColor: '#f8f9fa', borderRadius: '10px', padding: '1rem', marginBottom: '1rem' }}>
                        <div><b>Número do PAF:</b> {list.numero}</div>
                        <div><b>CPF/CNPJ atual:</b> {list.cpfCnpj}</div>
                        <div><b>Estabelecimento atual:</b> {list.estabelecimento}</div>
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '0.5rem' }}>Buscar novo estabelecimento por CPF/CNPJ</label>
                        <input
                            type="text"
                            value={buscaTransferencia}
                            onChange={this.handleBuscaTransferenciaChange}
                            placeholder="Digite CPF ou CNPJ"
                            style={{ width: '100%', border: '1px solid #ced4da', borderRadius: '8px', padding: '0.75rem' }}
                        />
                        <small>Digite parte do documento para localizar o estabelecimento de destino.</small>
                    </div>

                    <div style={{ maxHeight: '240px', overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: '8px', marginBottom: '1rem' }}>
                        {buscandoTransferencia ? (
                            <div style={{ padding: '0.75rem' }}>Buscando estabelecimentos...</div>
                        ) : resultadosTransferencia.length > 0 ? resultadosTransferencia.map(item => {
                            const selecionado = estabelecimentoSelecionado && String(estabelecimentoSelecionado._id) === String(item._id)
                            return (
                                <button
                                    key={item._id}
                                    type="button"
                                    onClick={() => this.selecionarEstabelecimentoTransferencia(item)}
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        borderBottom: '1px solid #e9ecef',
                                        backgroundColor: selecionado ? '#d1ecf1' : '#fff',
                                        textAlign: 'left',
                                        padding: '0.85rem 1rem',
                                        cursor: 'pointer'
                                    }}>
                                    <div><b>{item.cpfCnpj}</b></div>
                                    <div>{item.estabelecimento}</div>
                                </button>
                            )
                        }) : (
                            <div style={{ padding: '0.75rem' }}>
                                {buscaTransferencia ? 'Nenhum estabelecimento encontrado para o documento informado.' : 'Digite um CPF/CNPJ para buscar estabelecimentos.'}
                            </div>
                        )}
                    </div>

                    <div style={{ backgroundColor: estabelecimentoSelecionado ? '#e9f7ef' : '#fff3cd', borderRadius: '8px', padding: '0.85rem', marginBottom: '1rem' }}>
                        {estabelecimentoSelecionado ? (
                            <span><b>Destino selecionado:</b> {estabelecimentoSelecionado.cpfCnpj} - {estabelecimentoSelecionado.estabelecimento}</span>
                        ) : (
                            <span>Selecione um estabelecimento de destino antes de confirmar.</span>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
                        <button type="button" onClick={this.fecharModalTransferencia} disabled={transferindoPropriedade} style={{ border: 'none', backgroundColor: '#6c757d', color: '#fff', borderRadius: '8px', padding: '0.7rem 1.1rem' }}>Cancelar</button>
                        <button type="button" onClick={this.confirmarTransferenciaPropriedade} disabled={transferindoPropriedade} style={{ border: 'none', backgroundColor: '#8d0801', color: '#fff', borderRadius: '8px', padding: '0.7rem 1.1rem' }}>
                            {transferindoPropriedade ? 'Transferindo...' : 'Confirmar transferência'}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.list) return null

        let data = ""
        if (this.state.list.data) {
            let ano = String(this.state.list.data).slice(0, 4)
            let mes = String(this.state.list.data).slice(5, 7)
            let dia = String(this.state.list.data).slice(8, 10)
            data = `${dia}/${mes}/${ano}`
        }

        return (
            <div className="container mx-auto">
                <div className="d-flex flex-column align-items-start">
                    <label className="col-12 mt-5 text-left"><b>CPF/CNPJ: {this.state.list.cpfCnpj}</b></label>
                    <label className="col-12 mt-2 text-left"><b>{this.state.list.numero}: {this.state.list.estabelecimento}</b></label>
                    {this.renderBotaoTransferencia()}
                </div>
                {this.renderModalTransferencia()}
                <div className="text-center mx-auto">
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>USUÁRIO</th>
                                <th>TIPO</th>
                                <th>ID</th>
                                <th>DATA</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <td>{this.state.list.nome}</td>
                            <td>Capa do PAF</td>
                            <td></td>
                            <td>{data}</td>
                            <td>
                                <Link to={`/pafCapa/${this.state.list._id}`} target="_blank">
                                    <button style={{
                                        border: "none", backgroundColor: "#28a745", outline: "none",
                                        height: "25px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                    }}>Abrir</button>
                                </Link>
                                <Link to={`/capaPafEdicao/${this.state.list._id}`} target="_blank">
                                    <button style={{
                                        border: "none", backgroundColor: "#007bff", outline: "none",
                                        height: "25px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                    }}>Editar</button>
                                </Link>
                            </td>
                            {this.renderTotal()}
                        </tbody>
                    </table>
                </div>

                <Link to={{ pathname: `/fisio/${this.state.list._id}` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Termo de Visita - FISIO</button>
                </Link>

                <Link to={{ pathname: `/to/${this.state.list._id}` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Termo de Visita - T.O.</button>
                </Link>

                <Link to={{ pathname: `/despachoNovo/${this.state.list._id}` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Despacho</button>
                </Link>

                <Link to={{ pathname: `/certidao/${this.state.list._id}`, search: `paf` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Certidão</button>
                </Link>

                <Link to={{ pathname: `/anexo/${this.state.list._id}`, search: `paf` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Anexo</button>
                </Link>

                <Link to={{ pathname: `/ai/${this.state.list._id}`, search: `paf` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Auto de Infração</button>
                </Link>

                <Link to={{ pathname: `/imprimirpaf/${this.state.list._id}` }}>
                    <button style={{
                        border: "none", backgroundColor: "#036666", outline: "none",
                        height: "30px", marginBottom: "3vh", marginTop: "2vh",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Imprimir Processo</button>
                </Link>

                {this.renderAlerta()}
            </div>
        )
    }

    renderCod(ficha) {
        if (ficha.cod) {
            return <td style={{ pageBreakInside: 'auto' }}>{ficha.cod}</td>
        } else {
            return <td></td>
        }
    }

    renderTotal() {
        if (this.state.total) {
            return this.state.total.map(ficha => {
                let createdAtStr = String(ficha.createdAt || '')
                let ano = createdAtStr.slice(0, 4)
                let mes = createdAtStr.slice(5, 7)
                let dia = createdAtStr.slice(8, 10)
                let data = dia + "/" + mes + "/" + ano

                const rowKey = String(ficha._id || ficha.id || Math.random())

                const highlighted = this.isHighlightedFicha(ficha)
                const highlightProps = {
                    ref: node => this.setHighlightedRowRef(node, ficha),
                    style: this.getLinhaOcultaStyle(ficha)
                }

                if (ficha.url) {
                    return (
                        <tr key={rowKey} {...highlightProps}>
                            <td>{ficha.user}</td>
                            <td>Anexo - {ficha.tipo} - {ficha.name}{highlighted ? ' • Referenciado no chamado' : ''}</td>
                            {this.renderCod(ficha)}
                            <td>{data}</td>
                            <td>
                                <button style={{
                                    border: "none", backgroundColor: "#6c757d", outline: "none",
                                    height: "25px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF", marginRight: "0.5vw"
                                }} onClick={() => this.moverAnexo(ficha._id, 'up')}>↑</button>
                                <button style={{
                                    border: "none", backgroundColor: "#6c757d", outline: "none",
                                    height: "25px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                }} onClick={() => this.moverAnexo(ficha._id, 'down')}>↓</button>
                                <button style={{
                                    border: "none", backgroundColor: "#28a745", outline: "none",
                                    height: "25px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                }} onClick={e => this.redirect(ficha.url)}>Abrir</button>
                                {this.renderEdit(ficha._id)}
                                {this.botaoExcluir(ficha._id, "anexo")}
                            </td>
                        </tr>
                    )
                } else if (ficha.certidao) {
                    if (!this.deveRenderizarFichaOculta(ficha)) {
                        return null
                    } else {
                        return (
                            <tr key={rowKey} {...highlightProps}>
                                <td>{ficha.user}</td>
                                <td>Certidão{this.renderBadgeOculto(ficha)}</td>
                                {this.renderCod(ficha)}
                                <td>{data}</td>
                                <td>
                                    <Link to={`/certidaoView/${ficha._id}paf`} target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#28a745", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Abrir</button>
                                    </Link>
                                    {this.renderBotaoVisibilidade(ficha._id, "certidao", ficha.oculto)}
                                    {this.botaoExcluir(ficha._id, "certidao")}
                                </td>
                            </tr>
                        )
                    }
                } else if (ficha.fonte) {
                    if (!this.deveRenderizarFichaOculta(ficha)) {
                        return null
                    } else {
                        return (
                            <tr key={rowKey} {...highlightProps}>
                                <td>{ficha.user}</td>
                                <td>Despacho{this.renderBadgeOculto(ficha)}</td>
                                {this.renderCod(ficha)}
                                <td>{data}</td>
                                <td>
                                    {ficha.despachos && ficha.despachos.length > 0 ? (
                                        <Link to={`/despachoNovoView/${ficha._id}?${this.props.match.params.id}`}
                                            target="_blank" params={ficha}>
                                            <button style={{
                                                border: "none", backgroundColor: "#28a745", outline: "none",
                                                height: "25px",
                                                paddingLeft: "12px", paddingRight: "12px",
                                                borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                            }}>Abrir</button>
                                        </Link>
                                    ) : (
                                        <Link to={`/despachoView/${ficha._id}paf`} target="_blank" params={ficha}>
                                            <button style={{
                                                border: "none", backgroundColor: "#28a745", outline: "none",
                                                height: "25px",
                                                paddingLeft: "12px", paddingRight: "12px",
                                                borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                            }}>Abrir</button>
                                        </Link>
                                    )}
                                    {this.renderBotaoVisibilidade(ficha._id, "despacho", ficha.oculto)}
                                    {this.botaoExcluir(ficha._id, "despacho")}
                                </td>
                            </tr>
                        )
                    }
                } else {
                    if (!this.deveRenderizarFichaOculta(ficha)) {
                        return null
                    } else if (ficha.tipo == "Debito" || ficha.tipo == "Branco") {
                        var tipo = "aiView"
                        return (
                            <tr key={rowKey} {...highlightProps}>
                                <td>{ficha.funcionario}</td>
                                <td>A.I - {ficha.tipo}{this.renderBadgeOculto(ficha)}</td>
                                {this.renderCod(ficha)}
                                <td>{data}</td>
                                <td>
                                    <Link to={`/${tipo}/${ficha.id}paf`} target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#28a745", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Abrir</button>
                                    </Link>
                                    {this.renderBotaoVisibilidade(ficha.id, "documento", ficha.oculto)}
                                    {this.botaoExcluir(ficha.id, "ai")}
                                </td>
                            </tr>
                        )
                    } else if (ficha.profissao) {
                        let processo = this.props.match.params.id
                        if (ficha.profissao === "Fisioterapia") {
                            var urlView = "tvFisioView"
                            var urlEdit = "editFisio"
                        } else {
                            var urlView = "tvToView"
                            var urlEdit = "editTo"
                        }

                        return (
                            <tr key={rowKey} {...highlightProps}>
                                <td>{ficha.funcionario}</td>
                                <td>TV - {ficha.tipo}{this.renderBadgeOculto(ficha)}</td>
                                {this.renderCod(ficha)}
                                <td>{data}</td>
                                <td>
                                    <Link to={{ pathname: `/${urlView}/${ficha.id}`, search: `${processo}` }} target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#28a745", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Abrir</button>
                                    </Link>
                                    <Link to={{
                                        pathname: `/${urlEdit}/${ficha.id}`,
                                        search: `${processo}`
                                    }}
                                        target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#007bff", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Editar</button>
                                    </Link>
                                    {this.renderBotaoVisibilidade(ficha.id, "documento", ficha.oculto)}
                                    <button style={{
                                        border: "none", backgroundColor: "#343a40", outline: "none",
                                        height: "25px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                    }} onClick={e => this.deleteTv({
                                        idTv: ficha.id, idPaf: this.props.match.params.id, profissao: ficha.profissao
                                    })}>Excluir</button>
                                </td>
                            </tr>
                        )
                    } else {
                        if (ficha.tipo == "Consultório T.O") {
                            var tipo = "toView"
                            var edit = "consultorioTOEdit"
                        } else if (ficha.tipo == "Consultório Fisioterapia") {
                            var tipo = "fisioView"
                            var edit = "consultorioFisioEdit"
                        } else if (ficha.tipo == "Fechado") {
                            var tipo = "fechadoView"
                            var edit = "fechadoEdit"
                        } else if (ficha.tipo == "CAPS Fisioterapia") {
                            var tipo = "capsFisioView"
                            var edit = "capsFisioEdit"
                        } else if (ficha.tipo == "CAPS T.O") {
                            var tipo = "capsTOView"
                            var edit = "capsTOEdit"
                        } else if (ficha.tipo == "Clínica Fisioterapia") {
                            var tipo = "clinicaFisioView"
                            var edit = "clinicaFisioEdit"
                        } else if (ficha.tipo == "Clínica T.O") {
                            var tipo = "clinicaTOView"
                            var edit = "clinicaTOEdit"
                        } else if (ficha.tipo == "CER T.O") {
                            var tipo = "cerTOView"
                            var edit = "cerTOEdit"
                        } else if (ficha.tipo == "Nasf Fisioterapia") {
                            var tipo = "nasfFisioView"
                            var edit = "nasfFisioEdit"
                        } else if (ficha.tipo == "Nasf T.O") {
                            var tipo = "nasfTOView"
                            var edit = "nasfTOEdit"
                        } else if (ficha.tipo == "Ilegal") {
                            var tipo = "ilegalView"
                            var edit = "ilegalEdit"
                        } else if (ficha.tipo == "Rede Social") {
                            var tipo = "socialView"
                            var edit = "socialEdit"
                        } else if (ficha.tipo == "Ilpi Fisioterapia") {
                            var tipo = "ilpiFisioView"
                            var edit = "ilpiFisioEdit"
                        } else if (ficha.tipo == "Ilpi T.O") {
                            var tipo = "ilpiTOView"
                            var edit = "ilpiTOEdit"
                        } else if (ficha.tipo == "Hospital Fisioterapia") {
                            var tipo = "hospitalFisioView"
                            var edit = "hospitalFisioEdit"
                        } else if (ficha.tipo == "Hospital T.O") {
                            var tipo = "hospitalTOView"
                            var edit = "hospitalTOEdit"
                        } else if (ficha.tipo == "Branco TV") {
                            var tipo = "brancoView"
                            var edit = "brancoEdit"
                        }

                        let processo = this.props.match.params.id
                        return (
                            <tr key={rowKey} {...highlightProps}>
                                <td>{ficha.funcionario}</td>
                                <td>TV - {ficha.tipo}{this.renderBadgeOculto(ficha)}</td>
                                {this.renderCod(ficha)}
                                <td>{data}</td>
                                <td>
                                    <Link to={{ pathname: `/${tipo}/${ficha.id}`, search: `${processo}` }} target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#28a745", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Abrir</button>
                                    </Link>
                                    <Link to={{
                                        pathname: `/${edit}/${ficha.id}`,
                                        search: `${processo}`
                                    }}
                                        target="_blank" params={ficha}>
                                        <button style={{
                                            border: "none", backgroundColor: "#007bff", outline: "none",
                                            height: "25px",
                                            paddingLeft: "12px", paddingRight: "12px",
                                            borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                        }}>Editar</button>
                                    </Link>
                                    {this.renderBotaoVisibilidade(ficha.id, "documento", ficha.oculto)}
                                    {this.botaoExcluir(ficha.id, "tv", ficha.tipo)}
                                </td>
                            </tr>
                        )
                    }
                }
            })
        }
    }

    botaoExcluir(id, tipo, excluir) {
        if (localStorage.tipo === "interno") {
            return (
                <button style={{
                    border: "none", backgroundColor: "#343a40", outline: "none",
                    height: "25px",
                    paddingLeft: "12px", paddingRight: "12px",
                    borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                }} onClick={e => this.excluir(id, tipo, excluir)}>Excluir</button>
            )
        } else {
            return null
        }
    }

    renderEdit(id) {
        if (localStorage.tipo == "interno") {
            return (
                <Link to={{
                    pathname: `/editAnexo/${this.state.list._id}`,
                    search: id
                }} target="_blank">
                    <button style={{
                        border: "none", backgroundColor: "#007bff", outline: "none",
                        height: "25px",
                        paddingLeft: "12px", paddingRight: "12px",
                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                    }}>Editar</button>
                </Link>
            )
        } else {
            return <div></div>
        }
    }

    renderAlerta() {
        if (!this.state.list.alerta) {
            return <button style={{
                border: "none", backgroundColor: "#036666", outline: "none",
                height: "30px", marginBottom: "3vh", marginTop: "2vh",
                paddingLeft: "12px", paddingRight: "12px",
                borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
            }} onClick={e => this.alerta()}><a>Criar Alerta</a></button>
        } else {
            return <button style={{
                border: "none", backgroundColor: "#036666", outline: "none",
                height: "30px", marginBottom: "3vh", marginTop: "2vh",
                paddingLeft: "12px", paddingRight: "12px",
                borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
            }} onClick={e => this.alerta()}><a>Remover Alerta</a></button>
        }
    }
}
